// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:28:48

export default {
  "id": "detective-logic-puzzles",
  "slug": "detective-logic-puzzles",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/5dec34553957499994689aebab6f5e77-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/5dec34553957499994689aebab6f5e77/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Detective - Logic Puzzles",
      "description": "Become a Detective! Solve logic puzzles to find the criminal! \nLots of levels and interesting stories!\n\nYou will have to solve a lot of different cases, in this you will be helped by the method of deduction known to all detectives.",
      "instructions": "1) Use the hints to put ticks or crosses on the field.\n\n2) When the whole field is marked, the case is solved.\n\n3) Play the extra mode to earn clues and unlock a new story!",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1player",
        "2d",
        "logic",
        "tetris"
      ]
    },
    "zh-CN": {
      "title": "侦探 - 逻辑谜题",
      "description": "成为侦探！解决逻辑谜题以找出罪犯！\n众多关卡和有趣的故事！\n\n你将需要解决许多不同的案件，在此过程中，你将得到所有侦探都熟知的推理方法的帮助。",
      "instructions": "1) 使用提示在场上打勾或叉。\n\n2) 当整个场被打上标记时，案件即告解决。\n\n3) 玩额外模式以获得线索并解锁新故事！",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "1玩家",
        "2D",
        "逻辑",
        "俄罗斯方块"
      ]
    },
    "zh-TW": {
      "title": "探險家 -邏輯謎題",
      "description": "成為一名偵探！解謎來找出犯罪者！\n無數關卡和有趣的故事！\n\n你將必須解決許多不同的案件，這裡你將會得到所有偵探都知道的歸納法方法的幫助。",
      "instructions": "1) 使用提示在場地上標記勾號或叉號。\n\n2) 當整個場地都被標記後，案件就解決了。\n\n3) 遊玩額外模式以獲得提示並解鎖新故事！",
      "genres": [
        "休闲",
        "謎題"
      ],
      "tags": [
        "1玩家",
        "2D",
        "運籌",
        "雀士"
      ]
    },
    "zh-HK": {
      "title": "偵探 -邏輯謎題",
      "description": "成為一名偵探！解開邏輯謎題，找出罪犯！\n多個關卡和有趣的故事情節！\n\n你將需要解開多個不同的案件，在此過程中，你將得到所有偵探都熟知的邏輯推論方法的幫助。",
      "instructions": "1) 使用提示在場地上面標記勾號或十字號。\n\n2) 當整個場地都被標記後，案件便會解開。\n\n3) 遊玩額外模式以獲取線索並解鎖新故事！",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "1玩家",
        "2D",
        "運理",
        "魔方塊"
      ]
    },
    "ja": {
      "title": "探偵 - 逻辑パズル",
      "description": "探偵になる！論理パズルを解き、犯罪者を見つけ出せ！\n多くのレベルと面白い物語が待っています！\n\n多くの異なる事件を解決する必要があり、これは全ての探偵が知っている推論法で助けられます。",
      "instructions": "1) ヒントを使ってフィールドにチェックマークやストライクを入れてください。\n\n2) フィールドがすべてマークされたら、事件が解決します。\n\n3) 過度なモードをプレイしてヒントを獲得し、新しいストーリーを解鎖してください！",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "2D",
        "ロジック",
        "テトリス"
      ]
    },
    "ko": {
      "title": "감찰관 - 논리 퍼즐",
      "description": "탐정이 되어라! 범죄자를 찾기 위해 논리적 패자를 해결하라! \n다양한 레벨과 흥미로운 이야기들이 가득하다!\n\n다양한 사건들을 해결해야 하며, 이를 위해 모든 탐정들이 알고 있는 유리 추론 방법을 받을 수 있다.",
      "instructions": "1) 힌트를 사용하여 필드에 티크나 십자가를 찍으세요.\n\n2) 전체 필드가 표시되면 사건이 해결됩니다.\n\n3) 추가 모드를 플레이하여 힌트를 얻고 새로운 이야기를 해금하세요!",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "1플레이어",
        "2D",
        "로직",
        "테트리스"
      ]
    },
    "fr": {
      "title": "Detective - Énigmes de logique",
      "description": "Devenez un détective ! Résolvez des puzzles de logique pour trouver le criminel ! \nBeaucoup de niveaux et d'histoires intéressantes !\n\nVous devrez résoudre de nombreux cas différents, dans lesquels vous serez aidé par la méthode de déduction connue de tous les détectives.",
      "instructions": "1) Utilisez les indices pour placer des croix ou des ronds sur le champ.\n\n2) Lorsque tout le champ est marqué, le cas est résolu.\n\n3) Jouez au mode bonus pour gagner des indices et déverrouiller une nouvelle histoire !",
      "genres": [
        "Facile",
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "2D",
        "logique",
        "Tetris"
      ]
    }
  }
};
